export const LOGIN_DASHBOARD_URL = "https://app.notifystudio.com/login?redirect=dashboard";
export const SIGNUP_DASHBOARD_URL = "https://app.notifystudio.com/register?redirect=dashboard";

export function normalizePublicCtaUrl(value?: string | null) {
  if (!value) return value ?? "";

  const trimmed = value.trim();
  if (!trimmed) return trimmed;

  const normalized = trimmed.toLowerCase();

  if (
    normalized === "/login" ||
    normalized.startsWith("/login?") ||
    normalized.startsWith("/login/") ||
    normalized.includes("/login") ||
    normalized.includes("signin") ||
    normalized.includes("sign-in")
  ) {
    return LOGIN_DASHBOARD_URL;
  }

  if (
    normalized === "/signup" ||
    normalized.startsWith("/signup?") ||
    normalized.startsWith("/signup/") ||
    normalized.includes("/signup") ||
    normalized.includes("/register") ||
    normalized.includes("sign-up") ||
    normalized.includes("create-account")
  ) {
    return SIGNUP_DASHBOARD_URL;
  }

  if (normalized.includes("demo")) {
    return SIGNUP_DASHBOARD_URL;
  }

  return trimmed;
}